export function getColors(): string[] {
  return [
    '#1FBAA4', '#3F811A', '#B0BA1F', '#EFAA32', '#C83131', '#E54997',
    '#7A24AA', '#4E1ED4', '#2699FB', '#DF3030', '#BC6138', '#FF9900',
    '#FFD500', '#BBCE10', '#3BD12B', '#059B00', '#08E9D2', '#06BBFF',
    '#0066FF', '#2822CE', '#9635EB', '#6F0DC5', '#CC008F', '#FC4DC8'
  ];
}
